import React from "react";
import { getLegal, LAST_UPDATED } from "../data/legal";

const Block = ({ block }) => (
  <div className="mb-8">
    {block.h && (
      <h2 className="font-serif-display text-[24px] md:text-[28px] font-medium mb-4 mt-2">{block.h}</h2>
    )}
    {block.p &&
      block.p.map((para, i) => (
        <p key={i} className="text-[15px] md:text-[16px] leading-[1.8] text-[#1A1A1A]/80 mb-4">
          {para}
        </p>
      ))}
    {block.ul && (
      <ul className="space-y-2.5 my-4 list-disc pl-5">
        {block.ul.map((item, i) => (
          <li key={i} className="text-[15px] leading-relaxed text-[#1A1A1A]/80">{item}</li>
        ))}
      </ul>
    )}
  </div>
);

const Legal = ({ docKey }) => {
  const doc = getLegal(docKey);
  return (
    <main className="bg-[#F4EFE8]">
      <section className="bg-[#EDE6DC] py-14 md:py-20">
        <div className="max-w-[820px] mx-auto px-5 md:px-8">
          <p className="text-[12px] tracking-[0.3em] uppercase text-[#8a6d3b] mb-3">Legal</p>
          <h1 className="font-serif-display text-[38px] md:text-[56px] leading-[1.03] font-medium">{doc.title}</h1>
          <p className="text-[13px] text-[#1A1A1A]/50 mt-4">Last updated: {LAST_UPDATED}</p>
        </div>
      </section>

      <article className="max-w-[820px] mx-auto px-5 md:px-8 py-12 md:py-16">
        <p className="text-[16px] md:text-[17px] leading-[1.8] text-[#1A1A1A]/80 mb-10 pb-10 border-b border-[#1A1A1A]/10">
          {doc.intro}
        </p>
        {doc.sections.map((block, i) => (
          <Block key={i} block={block} />
        ))}
      </article>
    </main>
  );
};

export default Legal;
